import { useEffect, useState } from "react";
import { Coins, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Term } from "@/components/Term";

const Flag = ({ v }) => {
  if (v === true) return <span className="px-1.5 py-0.5 rounded border border-emerald-900/60 bg-emerald-950/40 text-emerald-300 text-[10px] font-semibold">Coinbase USD</span>;
  if (v === false) return <span className="px-1.5 py-0.5 rounded border border-slate-800 bg-slate-900/60 text-slate-400 text-[10px] font-semibold">no Coinbase market</span>;
  return <span className="px-1.5 py-0.5 rounded border border-amber-900/60 bg-amber-950/40 text-amber-300 text-[10px] font-semibold">unknown</span>;
};

// Which coins the daily recorder covers and which of them can also get rule-engine (exchange-candle) decisions.
export const CoverageUniverse = () => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/predictions/coverage").then((r) => setD(r.data)).catch((e) => setErr(e?.response?.data?.detail?.message || e?.response?.data?.detail || "Could not load coverage")); }, []);
  return (
    <div className="apx-card p-5 md:p-6 space-y-3" data-testid="coverage-universe">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-display font-semibold text-base text-slate-100"><Coins className="w-5 h-5 text-amber-300" /> Covered coins {d && <span className="text-sm font-normal text-slate-400">· {d.count}</span>}</div>
        {d?.coverage_as_of && <div className="text-[11px] text-slate-500 font-mono-ticker" data-testid="coverage-as-of">coverage from scanner run · {new Date(d.coverage_as_of).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}</div>}
      </div>
      {d && <p className="text-xs text-slate-400 max-w-3xl">{d.rule} Coins without a Coinbase USD market therefore receive AI records only.</p>}
      {err && <div className="text-sm text-rose-200" data-testid="coverage-error">{err}</div>}
      {!d && !err && <div className="flex items-center gap-2 text-slate-400 text-sm"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>}
      {d && (
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="coverage-table">
            <thead className="text-[10px] uppercase tracking-wider text-slate-500"><tr className="text-left"><th className="py-1.5 pr-3">#</th><th className="py-1.5 pr-3">Coin</th><th className="py-1.5 pr-3"><Term k="coverage_market" side="bottom">Exchange market</Term></th><th className="py-1.5 pr-3"><Term k="recorder_run" side="bottom">Records per run</Term></th><th className="py-1.5 pr-3"><Term k="ledger_origin" side="bottom">Scheduled records sealed</Term></th></tr></thead>
            <tbody className="divide-y divide-slate-900">
              {d.coins.map((c) => (
                <tr key={c.coin_id} data-testid={`coverage-row-${c.coin_id}`} data-coinbase={String(c.coinbase_usd_market)}>
                  <td className="py-1.5 pr-3 text-slate-500">{c.market_cap_rank ?? "—"}</td>
                  <td className="py-1.5 pr-3 text-slate-200"><span className="font-mono-ticker">{c.symbol || c.coin_id}</span>{c.name && <span className="text-slate-500"> · {c.name}</span>}</td>
                  <td className="py-1.5 pr-3"><Flag v={c.coinbase_usd_market} /></td>
                  <td className="py-1.5 pr-3 text-slate-300">{c.records}</td>
                  <td className="py-1.5 pr-3 font-mono-ticker text-slate-200">{c.scheduled_records}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
